import axiosInstance from "@/api/axios";
// import toastService from "@/services/toastService";

export const createUser = async (data: { name: string; email?: string,product_id?:string,group_ids:Array<number>,password:string }) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/users",
        data: data,
      });
      console.log("response", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  export const updateUser = async (data: {bmp_user_id:string,updates :{name: string; email?: string,product_id?:string,group_ids:Array<number>}}) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "PUT",
        url: "/odoo/api/v1/users",
        data: data,
      });
      console.log("response", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };
  // export const updateStage = async (
  //   data: { id: number; updates: { name?: string; is_won?: boolean; requirements?: string; team_id?: number } }
  // ) => {
  //   try {
  //     const response = await axiosInstance.put("/odoo/api/v1/crm/config/stages", data);
  //     console.log("Update response:", response);
  //     return response.data;
  //   } catch (err) {
  //     console.error("Error updating stage:", err);
  //     throw err;
  //   }
  // };
  

  export const archiveUser = async (data:{bmp_user_id:string}) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/users/archive",
        data: data,
      });
      console.log("response", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  export const unarchiveUser = async (bmp_user_id:string,product_id:string) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/users/assignProduct",
        data: {
          bmp_user_id:bmp_user_id,product_id:product_id
        }
      });
      console.log("response", response);
      // setColumns(response.data.data.data.stages);
      return response.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };

  export const fetchStageDetails = async (query: { id: number }) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: `/odoo/api/v1/crm/config/stages/details?id=${query.id}`, // ✅ Fixed string interpolation
      });
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error fetching stage details:", err);
      throw err; // Re-throw error for better error handling
    }
  };
  
  export const  fetchOrgUser = async (query: { page: number; limit: number; q?: string }) => {
    try {
      console.log(query)
      const response = await axiosInstance({
        method: "GET",
        url: `/odoo/api/v1/users`,
        params: {
          page: query.page,
          limit: query.limit,
          ...(query.q && { q: query.q }), // Only add 'q' if it exists
        },
      });
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error fetching stage details:", err);
      throw err;
    }
  };

  export const  fetchLicenses = async () => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: `/odoo/api/v1/licenses`,
        // params: {
        //   page: query.page,
        //   limit: query.limit,
        //   ...(query.q && { q: query.q }), // Only add 'q' if it exists
        // },
      });
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error fetching stage details:", err);
      throw err;
    }
  };

  export const  fetchGroups = async (query:{product_id:string}) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: `/odoo/api/v1/users/groups`,
        params: { product_id: query.product_id },
      });
  
      console.log("Response:", response);
      return response.data;
    } catch (err) {
      console.error("Error fetching stage details:", err);
      throw err;
    }
  };